import $ from 'jquery'
import 'slick-carousel'
export default () => {

  $('.reviews > .js-slider:visible').each(function () {
      const $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
          return;
      }

      if ($slider.children('.review').length < 2) return;

      $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: true,
          dots: true,
          infinite: false,
          rows: 0,
      });
  });

  $('.block-carousel > .js-slider:not(.carousel-ready)').each(function () {
      const $slider = $(this);
      const $carousel = $slider.children('.acf-innerblocks-container');

      if (!$carousel.length) return;

      const slideCount = $carousel.children('.block-carousel-slide').length;
      if (slideCount > 1) {
          const options = getSlickOptions($slider);
          $carousel.slick(options);
      }

      $slider.addClass('carousel-ready');
  });

  function getSlickOptions($el) {
      const raw = $el.attr('data-slick');

      if (!raw) return {};

      try {
          return JSON.parse(raw);
      } catch (e) {
          console.error('Invalid data-slick JSON', e);
          return {};
      }
  }
}
